import { Modal } from 'antd';
import React from 'react';
import { CloseIcon, ProfileOutlineIcon } from '../Common/Icons';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const UserHubModal = ({ data }) => {
  const trans = useSelector(translator);
  return (
    <Modal centered open={true} closable={false} footer={null}>
      <div className="userhubmodalcall">
        <div className="video-call-offline-container">
          <span className="video-call-offline-label">{data.status}</span>
        </div>
        <div className="image-container">
          <ProfileOutlineIcon image={data.image} />
        </div>
        <div className="video-call-device-name-container">
          <span className="video-call-device-name-label">{data.devicename}</span>
        </div>
        <div className="video-call-offline-dismiss-container" onClick={() => data?.cancel(data)}>
          <div className="video-call-offline-dismiss-block">
            <div className="video-call-offline-dismiss-icon-title">
              <CloseIcon className="video-call-offline-dismiss-icon" />
              <div className="video-call-offline-dismiss-label-block">
                <span className="video-call-offline-dismiss-label">{trans('DISMISS')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

UserHubModal.propTypes = {
  data: PropTypes.object,
};

export default UserHubModal;
